<h2 class="title">{{ 'CHANGE_PASS.TITLE' | translate }}</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-4">
  <!-- Password -->
  <div class="form-group mt-2">
    <label for="password">{{ 'CHANGE_PASS.PASSWORD' | translate }} <span class="req">*</span></label>
    <input id="password" class="form-control"
           formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
    <i class="icon password-icon"
       [ngClass]="{'icon-eye': showPassword, 'icon-eye-closed': !showPassword}"
       (click)="togglePasswordVisibility('password')"></i>
    <div *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
      <small *ngIf="form.get('password')?.errors?.['required']" class="text-danger">
        {{ 'CHANGE_PASS.ERRORS.PASSWORD_REQUIRED' | translate }}
      </small>
      <small *ngIf="form.get('password')?.errors?.['minlength']" class="text-danger">
        {{ 'CHANGE_PASS.ERRORS.PASSWORD_MIN' | translate }}
      </small>
    </div>
  </div>

  <!-- Confirm Password -->
  <div class="form-group mt-3">
    <label for="confirmPassword">{{ 'CHANGE_PASS.CONFIRM_PASSWORD' | translate }} <span class="req">*</span></label>
    <input id="confirmPassword" class="form-control"
           [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" />
    <i class="icon password-icon"
       [ngClass]="{'icon-eye': showConfirmPassword, 'icon-eye-closed': !showConfirmPassword}"
       (click)="togglePasswordVisibility('confirmPassword')"></i>
    <div *ngIf="form.get('confirmPassword')?.touched && (form.get('confirmPassword')?.invalid || form.hasError('passwordsMismatch'))">
      <small *ngIf="form.get('confirmPassword')?.errors?.['required']" class="text-danger">
        {{ 'CHANGE_PASS.ERRORS.CONFIRM_PASSWORD_REQUIRED' | translate }}
      </small>
      <small *ngIf="form.get('confirmPassword')?.errors?.['minlength']" class="text-danger">
        {{ 'CHANGE_PASS.ERRORS.CONFIRM_PASSWORD_MIN' | translate }}
      </small>
      <small *ngIf="form.hasError('passwordsMismatch')" class="text-danger">
        {{ 'CHANGE_PASS.ERRORS.PASSWORDS_MISMATCH' | translate }}
      </small>
    </div>
  </div>

  <small *ngIf="error" class="text-danger">
    {{ errorMessage ? errorMessage : ('CHANGE_PASS.ERRORS.GENERIC' | translate) }}
  </small>

  <!-- Submit Button -->
  <button type="submit" class="btn with-loader"
          [disabled]="!form.valid" *ngIf="!success">
    {{ 'CHANGE_PASS.BUTTON' | translate }}
    <span class="loader" *ngIf="loading"></span>
  </button>

  <h3 class="result-title" *ngIf="success">{{ 'CHANGE_PASS.SUCCESS' | translate }}</h3>
</form>
